// extracted by mini-css-extract-plugin
export default {"overlay":"Cz-z","bodyOpen":"Dz-z","content":"Ez-z","header":"Fz-z","close":"Gz-z","closeNoHeading":"Hz-z"};